<template>
    <div class="contenedor_facturador_">
        <div class="contenedor_productos">
            <div class="cuadro_menus">
                Usuario: {{ datos_usuario.nombre_completo }}
                <!-- <button v-if="datos_usuario.nivel == 1" type="button" class="btn btn-sm btn-outline-dark"
                    @click="cerrar_sesion">Cerrar Sesión</button>
                <button v-else type="button" class="btn btn-sm btn-outline-dark"
                    @click="regresar_al_escritorio">Regresar</button> -->
            </div>
            <div class="lista_productos">
                <div class="campo_busqueda_productos">
                    <b-container fluid="">
                        <b-row>
                            <div class="col-sm-8 mt-3">
                                <label for="campo_busqueda" class="form-label">Código</label>
                                <input type="text" id="campo_busqueda" autocomplete="off"
                                    @keydown.enter="consulta_producto_por_codigo" class="form-control form-control-sm"
                                    v-model="codigo">
                            </div>

                            <div class="col-sm-2 mt-3">
                                <label for="campo_cantidad" class="form-label">Cantidad</label>
                                <input type="number" id="campo_cantidad" @keydown.enter="consulta_producto_por_codigo"
                                    class="form-control form-control-sm" v-model="cantidad">
                            </div>

                            <div class="col-sm-2 mt-5">
                                <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                                    @click="consulta_producto_por_codigo">Agregar</button>
                            </div>
                        </b-row>
                    </b-container>
                </div>
                <div class="contenedor_lista_productos" @click="seleccionarCampoBusqueda">
                    <table class="table table-sm table-striped table-bordered" style="font-size: 12px;">

                        <thead>
                            <tr>
                                <th style="width: 10%;text-align: center;">
                                    Código
                                </th>
                                <th style="width: 30%;">
                                    Descripción
                                </th>
                                <th style="width: 5%;text-align: center;">
                                    Cantidad
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    Precio Tarjeta
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    Sub. T
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    Precio Efectivo
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    Sub. E
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    Descuento
                                </th>
                                <th style="width: 5%;text-align: center;">
                                    ...
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in carrito" :key="index">
                                <td style="text-align: center;">
                                    {{ item.codigo }}
                                </td>
                                <td>
                                    {{ item.nombre }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.cantidad }}
                                </td>
                                <!-- Precio tarjeta -->
                                <td style="text-align: center;">
                                    Q{{ item.precio.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    }) }}
                                </td>
                                <!-- Subtotal tarjeta -->
                                <td style="text-align: center;">
                                    Q{{ (item.precio * Math.abs(item.cantidad)).toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    }) }}
                                </td>
                                <!-- Precio efectivo -->
                                <td style="text-align: center;">
                                    Q{{ item.precio_efectivo.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    }) }}
                                </td>
                                <!-- Subtotal efectivo -->
                                <td style="text-align: center;">
                                    Q{{ (item.precio_efectivo *
                                        Math.abs(item.cantidad)).toLocaleString(undefined, {
                                            minimumFractionDigits: 2, maximumFractionDigits: 2
                                        }) }}
                                </td>

                                <!-- Descuento -->
                                <td style="text-align: center;">
                                    Q{{ ((item.precio - item.precio_efectivo) *
                                        Math.abs(item.cantidad)).toLocaleString(undefined, {
                                            minimumFractionDigits: 2, maximumFractionDigits: 2
                                        }) }}
                                </td>

                                <td style="text-align: center;">
                                    <button type="button" class="btn btn-sm btn-outline-danger" style="font-size: 10px;"
                                        @click="eliminar_del_carrito(index)"><i class="fas fa-trash"></i></button>
                                </td>
                            </tr>

                        </tbody>
                    </table>


                </div>
            </div>
            <div class="cuadro_botones_accion buttons-container">
                <div class="action-button" style="border-right: 1px solid #e9e9e9;" v-shortkey="['f1']"
                    @shortkey="guardar_compra" @click="guardar_compra"><i
                        class="fas fa-file-invoice-dollar mr-2"></i>Facturar (F1)</div>
                <div class="action-button" style="border-right: 1px solid #e9e9e9;" v-shortkey="['f2']"
                    @shortkey="guardar_recibos" @click="guardar_recibos"><i class="fas fa-receipt mr-2"></i>Recibos (F2)
                </div>
                <div class="action-button" style="border-right: 1px solid #e9e9e9;" v-shortkey="['f3']"
                    @shortkey="solicitar_descuento" @click="solicitar_descuento">
                    <i class="fas fa-percentage mr-2"></i>Solicitar descuento (F3)
                </div>
                <div class="action-button" v-shortkey="['f4']" @shortkey="abrir_modal_anticipos"
                    @click="abrir_modal_anticipos">
                    <i class="fas fa-money-bill-wave mr-2"></i>Anticipos (F4)
                </div>
            </div>
        </div>
        <div class="contenedor_datos_cliente">
            <div class="titulo_datos_cliente">
                <button v-if="datos_usuario.nivel == 1" type="button" class="btn btn-sm btn-outline-dark"
                    @click="cerrar_sesion">Cerrar Sesión</button>
                <button v-else type="button" class="btn btn-sm btn-outline-dark"
                    @click="regresar_al_escritorio">Regresar</button>
            </div>

            <div class="cuerpo_otros_datos">
                <div class="botones_fuciones_extras">
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="abrir_modal_listado"
                        style="margin-right: 5px;"><i class="fas fa-list"></i>
                        Solicitudes</button>

                    <button type="button" class="btn btn-sm btn-outline-dark" @click="abrir_modal_menu_extras"><i
                            class="fas fa-cog"></i>
                    </button>
                </div>
                <div class="contenedor_sobres">
                    <b-container fluid="">
                        <b-row>
                            <div class="col-sm-12">
                                <label for="" class="form-label">Sobres</label>
                                <select class="form-control form-control-sm" v-model="iniciales_sobres"
                                    @change="tomar_sobre">
                                    <option value="">Seleccionar</option>
                                    <option v-for="(item, index) in registros_sobres" :key="index" :value="item.id">{{
                                        item.iniciales }}</option>
                                </select>
                            </div>
                            <div class="col-sm-12 mt-2">
                                <div class="contenedor_correlativo"
                                    style="text-align: center;font-weight: bold;font-size: 25px">
                                    Correlativo <br>
                                    {{ correlativo }}
                                </div>
                                <!-- <label for="" class="form-label">Correlativo</label> -->
                                <!-- <input type="number" class="form-control form-control-sm" v-model="correlativo"> -->
                            </div>
                        </b-row>
                    </b-container>
                </div>
            </div>

            <div class="area_datos_cliente">
                <div class="contenedor_datos_cliente_">
                    <div class="campo-texto-nit">
                        {{ datos_cliente.nit }}
                    </div>
                    <div class="campo-texto-nombre">
                        {{ datos_cliente.nombre_cliente }}
                    </div>
                </div>
            </div>

            <div class="boton_total_factura" style="background-color: #f77200;">
                <div class="titulo_total">
                    Total con tarjeta
                </div>
                <div class="monto_total">
                    Q{{ gran_total.toLocaleString(undefined, {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                    }) }}
                </div>
            </div>

            <div class="boton_total_factura" style="background-color: #ff9919;">
                <div class="titulo_total">
                    Total en efectivo
                </div>
                <div class="monto_total">
                    Q{{ gran_total_muestra.toLocaleString(undefined, {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                    }) }}
                </div>
            </div>

            <div class="boton_total_factura" style="background-color: #ffc523;color: black !important;">
                <div class="titulo_total">
                    Total descuentos
                </div>
                <div class="monto_total" style="color: black !important;">
                    Q{{ total_descuentos.toLocaleString(undefined, {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                    }) }}
                </div>
            </div>
        </div>

        <VistaPreviaDescuento v-if="modal_solicitudes" v-on:salir="cerrar_modal" v-on:limpiar="limpiar_estado" />
        <ListadoDescuentos v-if="modal_listado_descuentos" v-on:salir="cerrar_modal_listado"
            v-on:ocultar_modal_listado="ocultar_modal_listado" />
        <DetalleDescuentos v-if="modal_detalle_descuento" v-on:salir="cerrar_modal_detalle" />
        <NoAutorizacion v-if="modal_no_autorizado" :accion="btn_accion" v-on:salir="cerrar_modal_no_autorizado"
            v-on:guardar="set_no_autorizacion" />
        <ModalContingencia v-if="modal_contingencia" :datos_certificacion="datos_certificacion"
            v-on:salir="cerrar_modal_contingencia" />
        <ModalMenuExtras v-if="modal_menu_extras" v-on:salir="cerrar_modal_menu_extras" />
        <ModalRegistroAnticipos v-if="modal_anticipos" v-on:salir="cerrar_modal_anticipos" :total="gran_total"
            v-on:actualizar="limpiar_estado" />
        <!-- <ModalEfectivoTarjeta v-if="modal_efectivo_tarjeta" :gtotal="gran_total" v-on:enviar_efectivo="set_efectivo"
            v-on:salir="cerrar_modal_efectivo_tarjeta" /> -->
        <Cargando v-if="loading_certificando" :titulo="'Certificando...'" />
        <Cargando v-if="loading_nit" :titulo="'Buscando...'" />
        <SolicitarNit v-if="modal_solicitar_nit" v-on:salir_modal_nit="cerrar_solicitar_nit" />
        <ModalDatosDePago v-if="modal_datos_de_pago" :gran_total="gran_total" :accion="btn_accion"
            v-on:cerrar_y_ejecutar="ejecutar_factura" v-on:cerrar_y_ejecutar_recibo="ejecutar_recibo"
            v-on:salir="cerrar_modal_forma_de_pago" />
    </div>
</template>

<script>
    import { atexto, minix, pregunta } from '@/components/functions/alertas';
    import { mapActions, mapState, mapMutations } from 'vuex';
    import moment from 'moment';
    import ListadoDescuentos from '@/components/Facturador/ModalListadoDescuentos.vue'
    import ModalMenuExtras from '@/components/Facturador/ModalMenuExtras.vue'
    import VistaPreviaDescuento from '@/components/Facturador/ModalVistaPrevia.vue'
    import DetalleDescuentos from '@/components/Facturador/ModalDetalleDescuento.vue'
    import NoAutorizacion from '@/components/Facturador/ModalNoAutorizacion.vue'
    import ModalContingencia from '../components/Modales/ModalContingencia.vue'
    import Cargando from '../components/Loading/Cargando.vue'
    // import ModalEfectivoTarjeta from '@/components/Facturador/ModalEfectivoTarjeta.vue'
    import SolicitarNit from '@/components/Facturador/SolicitarNit.vue'
    import ModalDatosDePago from '@/components/Facturador/ModalDatosDePago.vue'
    import ModalRegistroAnticipos from '@/components/Facturador/ModalRegistroAnticipos.vue'

    import pdfMake from 'pdfmake/build/pdfmake.js'
    import pdfFonts from 'pdfmake/build/vfs_fonts.js'
    pdfMake.addVirtualFileSystem(pdfFonts);

    export default {
        name: 'Facturador',
        computed: {
            ...mapState(['datos_usuario', 'id_empresa_seleccionada', 'nombre_empresa_seleccionada', 'datos_cliente', 'forma_de_pago'])
        },
        components: {
            ListadoDescuentos,
            ModalMenuExtras,
            VistaPreviaDescuento,
            DetalleDescuentos,
            NoAutorizacion,
            ModalContingencia,
            Cargando,
            // ModalEfectivoTarjeta,
            SolicitarNit,
            ModalDatosDePago,
            ModalRegistroAnticipos
        },
        data() {
            return {
                modal_listado_descuentos: false,
                modal_menu_extras: false,
                modal_solicitudes: false,
                modal_detalle_descuento: false,
                modal_no_autorizado: false,
                modal_anticipos: false,
                btn_accion: '',
                no_autorizacion: '',
                // dif_efectivo: 0,
                // dif_tarjeta: 0,
                nit_seteado: '',
                nombre_cliente_seteado: '',
                loading_certificando: false,
                loading_nit: false,
                datos_certificacion: {},
                modal_factura: false,
                modal_contingencia: false,
                modal_efectivo_tarjeta: false,
                codigo: '',
                cantidad: 1,
                nombre_producto: '',
                codigo_seleccionado: '',
                precio: 0,
                precio_efectivo: 0,
                precio_tarjeta: 0,
                formula: false,
                el_formula: [],
                carrito: [],
                tipo_de_pago: 'tarjeta',
                gran_total: 0,
                gran_total_muestra: 0,
                total_descuentos: 0,
                bloquear_tipo_de_pago: false,
                // nombre_cliente: '',
                // nit: '',
                precio_costo: 0,
                bloquear_entradas: false,
                nueva_venta: true,
                modal_solicitar_nit: false,
                modal_datos_de_pago: false,
                iniciales_sobres: '',
                registros_sobres: [],
                correlativo: 0,
            }
        },
        methods: {
            seleccionarCampoBusqueda() {
                document.getElementById('campo_busqueda').focus();
            },
            async consulta_producto_por_codigo() {

                if (this.codigo == '') {
                    minix({ icon: 'info', mensaje: 'Ingrese un codigo', tiempo: 3000 })
                    document.getElementById('campo_busqueda').focus()
                } else {

                    let cs = {
                        api: `articulos/c/consulta_articulo_facturador?codigo=${this.codigo.trim()}&sucursal=${this.datos_usuario.sucursal_asignada}&empresa=${this.id_empresa_seleccionada}`
                    }

                    let r = await this.obtener_data(cs)

                    if (r.length != 0) {
                        this.nombre_producto = r.nombre
                        this.codigo_seleccionado = r.codigo
                        this.precio = r.precio_venta
                        this.precio_efectivo = r.precio_efectivo
                        this.precio_tarjeta = r.precio_venta
                        this.formula = r.formula
                        this.el_formula = r.elementos_formula


                        this.agregar_al_carrito()

                        document.getElementById('campo_busqueda').select()
                    } else {
                        minix({ icon: 'info', mensaje: 'Producto no encontrado', tiempo: 3000 })
                        document.getElementById('campo_busqueda').select()
                    }
                }

            },
            agregar_al_carrito() {
                if (this.codigo_seleccionado == '' || this.nombre_producto == '') {
                    this.codigo = ''
                    minix({ icon: 'error', mensaje: 'Selecciona un producto', tiempo: 3000 })
                    document.getElementById('campo_busqueda').focus()
                } else {
                    let producto = {
                        codigo: this.codigo_seleccionado,
                        nombre: this.nombre_producto,
                        precio: this.precio,
                        precio_efectivo: this.precio_efectivo,
                        precio_tarjeta: this.precio_tarjeta,
                        cantidad: this.cantidad,
                        subtotal: this.precio * this.cantidad,
                        formula: this.formula,
                        tipo_de_pago: '', //this.tipo_de_pago,
                        elementos_formula: this.el_formula,
                        modal_listado_descuentos: false
                    }

                    this.carrito.push(producto)
                    this.suma_sutotales()


                    // Limpiar campos
                    this.nombre_producto = ''
                    this.codigo = ''
                    this.codigo_seleccionado = ''
                    this.precio = 0
                    this.precio_efectivo = 0
                    this.precio_tarjeta = 0
                    this.cantidad = 1
                    this.formula = false
                    this.el_formula = []

                    document.getElementById('campo_busqueda').focus()

                    if (this.nueva_venta) {
                        this.modal_solicitar_nit = true
                    }
                }
            },

            suma_sutotales() {
                let contador = 0
                let contador_muestra = 0

                for (let i = 0; i < this.carrito.length; i++) {
                    let e = this.carrito[i]
                    contador += e.subtotal
                    contador_muestra += e.precio_efectivo * e.cantidad

                    // if (this.tipo_de_pago == 'efectivo' || this.tipo_de_pago == 'EFECTIVO') {
                    //     contador_muestra += ((e.precio_efectivo) * e.cantidad)
                    // } else {
                    //     contador_muestra += e.subtotal
                    // }
                }

                this.gran_total = contador
                this.gran_total_muestra = contador_muestra
                this.total_descuentos = contador - contador_muestra
            },
            eliminar_del_carrito(index) {
                this.carrito.splice(index, 1)
                this.suma_sutotales()
                this.validar_carrito()
                document.getElementById('campo_busqueda').focus()
            },
            validar_carrito() {
                if (this.carrito.length == 0) {
                    this.bloquear_tipo_de_pago = false
                } else {
                    this.bloquear_tipo_de_pago = true
                }
            },
            regresar_al_escritorio() {
                if (this.datos_usuario.nivel == 0) {
                    this.$router.push({ name: 'Escritorio' })
                } else if (this.datos_usuario.nivel == 1) {
                    this.$router.push({ name: 'Empresas' })
                } else {
                    minix({ icon: 'info', mensaje: 'No tiene permisos para esta opción', tiempo: 3000 })
                }
            },
            abrir_modal_listado() {
                this.modal_listado_descuentos = true
            },
            cerrar_modal_listado() {
                this.modal_listado_descuentos = false
            },
            ocultar_modal_listado() {
                this.modal_listado_descuentos = false
                this.modal_detalle_descuento = true
            },
            cerrar_modal_detalle() {
                this.modal_detalle_descuento = false
                this.modal_listado_descuentos = true
            },
            cerrar_modal_no_autorizado() {
                this.modal_no_autorizado = false
            },
            abrir_modal_no_autorizado() {
                this.modal_no_autorizado = true
            },
            async set_no_autorizacion(e) {
                this.no_autorizacion = e
                if (this.btn_accion == 'facturas') {
                    await this.guardar_compra()
                } else {
                    await this.guardar_recibos()
                }
            },
            async ejecutar_factura() {

                if (this.iniciales_sobres == '' || this.correlativo == 0) {
                    minix({ icon: 'info', mensaje: 'Seleccione un sobre', tiempo: 3000 })
                    return
                }

                let f = {
                    api: `movimientos-cabeceras/g/ventas`,
                    formulario: {
                        total_movimiento: this.gran_total,
                        dif_efectivo: this.forma_de_pago.monto_efectivo,//this.dif_efectivo,
                        dif_tarjeta: this.forma_de_pago.monto_tarjeta,//this.dif_tarjeta,
                        sucursal: this.datos_usuario.sucursal_asignada,
                        listado: this.carrito,
                        vendedor: this.datos_usuario.id,
                        nit_cliente: this.datos_cliente.nit,//this.nit_seteado,
                        nombre_cliente: this.datos_cliente.nombre_cliente,//this.nombre_cliente_seteado.toUpperCase().trim(),
                        tipo_de_pago: this.forma_de_pago.tipo_de_pago,//this.tipo_de_pago,
                        no_autorizacion: this.forma_de_pago?.no_autorizacion.trim(),//this.no_autorizacion.trim(),
                        correlativo_sobres: this.correlativo,
                        iniciales_sobres: this.iniciales_sobres
                    }
                }

                this.loading_certificando = true
                let r = await this.guardar_data(f)
                this.loading_certificando = false

                this.nit = ''
                this.nit_seteado = ''
                // this.nombre_cliente_seteado = ''
                // this.nombre_cliente = ''
                this.nombre_producto = ''
                this.codigo = ''
                this.codigo_seleccionado = ''
                this.precio = ''
                this.cantidad = 1
                this.carrito = []
                this.gran_total = 0
                // this.tipo_de_pago = 'tarjeta'
                this.bloquear_tipo_de_pago = false
                this.no_autorizacion = ''
                // this.dif_efectivo = 0
                // this.dif_tarjeta = 0
                this.total_descuentos = 0
                this.gran_total_muestra = 0
                this.correlativo = 0
                this.iniciales_sobres = ''



                if (r.tipo_de_respuesta == 'certificado') {
                    this.datos_certificacion = r
                    this.abrir_modal_factura()
                    this.nueva_venta = true
                    this.modal_datos_de_pago = false
                    // this.modal_solicitar_nit = true
                    this.set_forma_de_pago({})
                    this.set_datos_cliente({})

                } else {
                    this.datos_certificacion = r
                    this.nueva_venta = true
                    // this.modal_solicitar_nit = true
                    this.modal_datos_de_pago = false
                    this.abrir_modal_contingencia()
                    this.set_forma_de_pago({})
                    this.set_datos_cliente({})
                }
            },
            async guardar_compra() {
                this.btn_accion = 'facturas'

                if (this.carrito.length == 0) {
                    atexto({ titulo: 'Error', cuerpo: 'No ha ingresado productos', icono: 'error' })
                } else {
                    if (this.datos_cliente.nit.trim() == '' || this.datos_cliente.nombre_cliente.trim() == '') {
                        minix({ icon: 'info', mensaje: 'Ingrese los datos del cliente', tiempo: 3000 })
                    } else {

                        this.modal_datos_de_pago = true

                    }
                }
            },
            async ejecutar_recibo() {
                if (this.iniciales_sobres == '' || this.correlativo == 0) {
                    minix({ icon: 'info', mensaje: 'Seleccione un sobre', tiempo: 3000 })
                    return
                }

                let f = {
                    api: `movimientos-cabeceras/g/recibo`,
                    formulario: {
                        total_movimiento: this.gran_total,
                        sucursal: this.datos_usuario.sucursal_asignada,
                        listado: this.carrito,
                        vendedor: this.datos_usuario.id,
                        nit_cliente: this.datos_cliente.nit,
                        nombre_cliente: this.datos_cliente.nombre_cliente.toUpperCase().trim(),
                        tipo_de_pago: this.forma_de_pago.tipo_de_pago,
                        no_autorizacion: this.forma_de_pago?.no_autorizacion.trim(),
                        dif_efectivo: this.forma_de_pago.monto_efectivo,
                        dif_tarjeta: this.forma_de_pago.monto_tarjeta,
                        correlativo_sobres: this.correlativo,
                        iniciales_sobres: this.iniciales_sobres
                    }
                }

                let r = await this.guardar_data(f)

                const docDefinition = {
                    pageSize: {
                        width: 226.77, // 80mm en puntos (1mm = 2.83465 puntos)
                        height: 'auto'
                    },
                    pageMargins: [5, 5, 5, 5], // Márgenes mínimos para impresora térmica
                    content: [
                        {
                            text: this.nombre_empresa_seleccionada,
                            style: 'header',
                            alignment: 'center'
                        },
                        {
                            text: r.establecimiento,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: r.direccion,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: '----------------------------------------',
                            alignment: 'center'
                        },
                        {
                            text: '*** RECIBO ***',
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: `NIT: ${this.datos_cliente.nit}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: `CLI: ${this.datos_cliente.nombre_cliente}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'DESCRIPCION', style: 'tableHeader', width: '58%' },
                                { text: 'CANT.', style: 'tableHeader', width: '20%' },
                                { text: 'MONTO', style: 'tableHeader', width: '22%' }
                            ]
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'Descuento', style: 'total_2', width: '70%' },
                                {
                                    text: this.forma_de_pago.tipo_de_pago == 'tarjeta' ? "Q.0.00" : `Q${r.datos_ventas.total_descuentos.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total_2', width: '30%'
                                }
                            ]
                        },
                        {
                            columns: [
                                { text: 'Total', style: 'total', width: '70%' },
                                {
                                    text: `Q${r.datos_ventas.total_movimiento.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total', width: '30%'
                                }
                            ]
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: 'Gracias por su compra',
                            bold: true,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '**',
                            style: 'pie_ticket',
                            alignment: 'center'
                        }
                    ],
                    styles: {
                        header: {
                            fontSize: 11,
                            bold: true,
                            margin: [0, 20, 0, 5]
                        },
                        subheader: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        normal: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        separador: {
                            fontSize: 11,
                            margin: [0, -5, 0, 0]
                        },
                        tableHeader: {
                            fontSize: 10,
                            bold: true,
                            margin: [6, -5, 5, 0]
                        },
                        descripcion: {
                            fontSize: 9,
                            margin: [6, 0, 0, 0]
                        },
                        cantidad: {
                            fontSize: 9,
                            margin: [30, 0, 0, 0]
                        },
                        monto: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        total: {
                            fontSize: 9,
                            bold: true,
                            margin: [130, 0, 0, 20]
                        },
                        total_2: {
                            fontSize: 9,
                            bold: true,
                            margin: [105, 0, 0, 0]
                        },
                        cantidad_total: {
                            fontSize: 9,
                            margin: [15, 0, 0, 20]
                        },
                        cantidad_total_2: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        espacio: {
                            fontSize: 10,
                            margin: [0, 0, 0, 10]
                        },
                        pie_ticket: {
                            fontSize: 10,
                            margin: [0, 50, 0, 0]
                        }
                    }
                };

                // Insertando de manera dinamica los productos
                let posicion_a_insertar = 10

                for (let i = 0; i < this.carrito.length; i++) {
                    const e = this.carrito[i];

                    docDefinition.content.splice(posicion_a_insertar, 0, {
                        columns: [
                            { text: e.nombre, style: 'descripcion', width: '50%' },
                            { text: e.cantidad, style: 'cantidad', width: '20%' },
                            {
                                text: `Q${(e.precio_tarjeta * e.cantidad).toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                })}`, style: 'monto', width: '30%'
                            }
                        ]
                    })

                    posicion_a_insertar++
                }

                // Crear y descargar el PDF
                pdfMake.createPdf(docDefinition).print();

                this.nit = ''
                this.nit_seteado = ''
                // this.nombre_cliente_seteado = ''
                // this.nombre_cliente = ''
                this.nombre_producto = ''
                this.codigo = ''
                this.codigo_seleccionado = ''
                this.precio = ''
                this.cantidad = 1
                this.carrito = []
                this.tipo_de_pago = 'tarjeta'
                this.bloquear_tipo_de_pago = false
                this.gran_total = 0
                this.no_autorizacion = ''
                // this.dif_efectivo = 0
                // this.dif_tarjeta = 0
                this.total_descuentos = 0
                this.gran_total_muestra = 0
                this.correlativo = 0
                this.iniciales_sobres = ''

                this.modal_datos_de_pago = false
                this.nueva_venta = true
                // this.modal_solicitar_nit = true
                this.set_forma_de_pago({})
                this.set_datos_cliente({})
            },
            async guardar_recibos() {
                this.btn_accion = 'recibos'

                if (this.carrito.length == 0) {
                    atexto({ titulo: 'Error', cuerpo: 'No ha ingresado productos', icono: 'error' })
                } else {
                    if (this.datos_cliente.nit.trim() == '' || this.datos_cliente.nombre_cliente.trim() == '') {
                        minix({ icon: 'info', mensaje: 'Ingrese los datos del cliente', tiempo: 3000 })
                    } else {
                        this.modal_datos_de_pago = true
                    }
                }
            },
            abrir_modal_factura() {
                // Definir el documento
                const docDefinition = {
                    pageSize: {
                        width: 226.77, // 80mm en puntos (1mm = 2.83465 puntos)
                        height: 'auto'
                    },
                    pageMargins: [5, 5, 5, 5], // Márgenes mínimos para impresora térmica
                    content: [
                        {
                            text: this.nombre_empresa_seleccionada,
                            style: 'header',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_certificacion.datos_cert.datos_sucursal.nombre_propietario,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_certificacion.datos_cert.datos_sucursal.direccion,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_certificacion.datos_cert.datos_sucursal.establecimiento,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: `NIT: ${this.datos_certificacion.datos_cert.datos_sucursal.nit}`,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: 'SUJETO A PAGOS TRIMESTRALES ISR.',
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: '----------------------------------------',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_usuario.nombre_sucursal_asignada,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: `NIT: ${this.datos_certificacion.datos_cert.datos_cliente.nit}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: `CLI: ${this.datos_certificacion.datos_cert.datos_cliente.nombre}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'DIR: CIUDAD',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'DESCRIPCION', style: 'tableHeader', width: '58%' },
                                { text: 'CANT.', style: 'tableHeader', width: '20%' },
                                { text: 'MONTO', style: 'tableHeader', width: '22%' }
                            ]
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'Descuento', style: 'total_2', width: '70%' },
                                {
                                    text: this.datos_certificacion.datos_cert.datos_venta.tipo_de_pago == 'tarjeta' ? "Q.0.00" : `Q${(this.datos_certificacion.datos_cert.datos_venta.total_descuentos).toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total_2', width: '30%'
                                }
                            ]
                        },
                        {
                            columns: [
                                { text: 'Total', style: 'total', width: '70%' },
                                {
                                    text: `Q${this.datos_certificacion.datos_cert.datos_venta.total_movimiento.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total', width: '30%'
                                }
                            ]
                        },
                        {
                            text: 'Documento Tributario Electrónico',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '** Factura **',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_certificacion.datos_cert.Serie,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'NÚMERO DE AUTORIZACIÓN:',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_certificacion.datos_cert.Autorizacion,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: `CERTIFICACIÓN: ${this.datos_certificacion.datos_cert.Fecha_de_certificacion}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: 'CERTIFICADOR NIT: 77454820',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'DIGIFACT SERVICIOS',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'SOCIEDAD ANONIMA',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: 'Gracias por su compra',
                            bold: true,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '**',
                            style: 'pie_ticket',
                            alignment: 'center'
                        }
                    ],
                    styles: {
                        header: {
                            fontSize: 11,
                            bold: true,
                            margin: [0, 20, 0, 5]
                        },
                        subheader: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        normal: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        separador: {
                            fontSize: 11,
                            margin: [0, -5, 0, 0]
                        },
                        tableHeader: {
                            fontSize: 10,
                            bold: true,
                            margin: [6, -5, 5, 0]
                        },
                        descripcion: {
                            fontSize: 9,
                            margin: [6, 0, 0, 0]
                        },
                        cantidad: {
                            fontSize: 9,
                            margin: [30, 0, 0, 0]
                        },
                        monto: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        total: {
                            fontSize: 9,
                            bold: true,
                            margin: [130, 0, 0, 20]
                        },
                        total_2: {
                            fontSize: 9,
                            bold: true,
                            margin: [105, 0, 0, 0]
                        },
                        cantidad_total: {
                            fontSize: 9,
                            margin: [15, 0, 0, 20]
                        },
                        cantidad_total_2: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        espacio: {
                            fontSize: 10,
                            margin: [0, 0, 0, 10]
                        },
                        pie_ticket: {
                            fontSize: 10,
                            margin: [0, 50, 0, 0]
                        }
                    }
                };

                // Insertando de manera dinamica los productos
                let posicion_a_insertar = 14

                for (let i = 0; i < this.datos_certificacion.datos_cert.datos_venta.listado.length; i++) {
                    const e = this.datos_certificacion.datos_cert.datos_venta.listado[i];

                    docDefinition.content.splice(posicion_a_insertar, 0, {
                        columns: [
                            { text: e.nombre, style: 'descripcion', width: '50%' },
                            { text: e.cantidad, style: 'cantidad', width: '20%' },
                            {
                                text: `Q${(e.precio_tarjeta * e.cantidad).toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                })}`, style: 'monto', width: '30%'
                            }
                        ]
                    })

                    posicion_a_insertar++
                }

                // Crear y descargar el PDF
                pdfMake.createPdf(docDefinition).print();
            },
            cerrar_modal_factura() {
                this.modal_factura = false
            },
            abrir_modal_contingencia() {
                this.modal_contingencia = true
            },
            cerrar_modal_contingencia() {
                this.modal_contingencia = false
            },
            abrir_modal_efectivo_tarjeta() {
                this.modal_efectivo_tarjeta = true
            },
            cerrar_modal_efectivo_tarjeta() {
                this.modal_efectivo_tarjeta = false
            },
            // async set_efectivo(efectivo) {
            //     this.dif_tarjeta = this.gran_total - efectivo
            //     this.dif_efectivo = efectivo

            //     this.cerrar_modal_efectivo_tarjeta()

            //     if (this.btn_accion == 'facturas') {
            //         await this.guardar_compra()
            //     } else {
            //         await this.guardar_recibos()
            //     }
            // },
            abrir_modal_menu_extras() {
                this.modal_menu_extras = true
            },
            cerrar_modal_menu_extras() {
                this.modal_menu_extras = false
            },
            abrir_modal_anticipos() {
                if (this.carrito.length == 0) {
                    minix({ icon: 'info', mensaje: 'No ha ingresado productos', tiempo: 3000 })
                    return
                }

                if (this.datos_cliente.nit.trim() == '' || this.datos_cliente.nombre_cliente.trim() == '') {
                    minix({ icon: 'info', mensaje: 'Ingrese los datos del cliente', tiempo: 3000 })
                    return
                }

                this.set_carrito_facturador(this.carrito)

                this.modal_anticipos = true
            },
            cerrar_modal_anticipos() {
                this.modal_anticipos = false
            },
            cerrar_modal() {
                this.modal_solicitudes = false
            },
            limpiar_estado() {
                // this.nit = ''
                // this.nombre_cliente = ''
                this.nombre_producto = ''
                this.codigo = ''
                this.codigo_seleccionado = ''
                this.precio = ''
                this.cantidad = 1
                this.carrito = []
                this.tipo_de_pago = ''
                this.bloquear_tipo_de_pago = false
                this.gran_total = 0
                this.set_forma_de_pago({})
                this.set_datos_cliente({})
                this.nueva_venta = true
                this.modal_solicitar_nit = false
                this.total_descuentos = 0
                this.gran_total_muestra = 0
            },
            solicitar_descuento() {
                if (!this.datos_cliente || Object.keys(this.datos_cliente).length === 0 || !this.datos_cliente.nit || !this.datos_cliente.nombre_cliente) {
                    minix({ icon: 'info', mensaje: 'Ingresa los datos del cliente o selecciona consumidor final', tiempo: 3000 })
                } else {
                    if (this.carrito.length == 0) {
                        minix({ icon: 'info', mensaje: 'No ha ingresado productos', tiempo: 3000 })
                    } else {

                        pregunta({ titulo: 'Solicitar descuento?', texto: 'Esta acción requiere aprobación', afirmacion: 'Si, solicitar...' }, async (i) => {
                            if (i) {
                                let datos = {
                                    dte: `SLD-${moment(Date.now()).format('YYMMHHMMSS')}`,
                                    total_movimiento: this.gran_total,
                                    sucursal: this.datos_usuario.sucursal_asignada,
                                    listado: this.carrito,
                                    vendedor: this.datos_usuario.id,
                                    nit_cliente: this.datos_cliente.nit || '',
                                    tipo_de_pago: Object.keys(this.forma_de_pago).length > 0 ? this.forma_de_pago.tipo_de_pago.toUpperCase() : '',
                                    nombre_cliente: this.datos_cliente.nombre_cliente.toUpperCase().trim()
                                }

                                this.set_obj_solicitud_descuento(datos)

                                this.modal_solicitudes = true
                            }
                        })
                    }
                }
            },

            cerrar_solicitar_nit() {
                this.nueva_venta = false
                this.modal_solicitar_nit = false
                document.getElementById('campo_busqueda').focus()
            },
            cerrar_modal_forma_de_pago() {
                this.modal_datos_de_pago = false
            },
            async obtener_correlativos_sobres() {
                let f = {
                    api: `correlativo-sobres?filters[empresa][$eq][0]=${this.id_empresa_seleccionada}&filters[sucursal][$eq][1]=${this.datos_usuario.sucursal_asignada}`
                }

                let r = await this.obtener_data(f)
                this.registros_sobres = r

            },
            async tomar_sobre() {
                if (this.iniciales_sobres != '') {
                    let f = {
                        api: `correlativo-sobres-movimientos/c/obtener-correlativo-actual?iniciales=${this.iniciales_sobres}&sucursal=${this.datos_usuario.sucursal_asignada}&empresa=${this.id_empresa_seleccionada}`
                    }

                    let r = await this.obtener_data(f)
                    this.correlativo = r.correlativo_actual
                } else {
                    this.correlativo = 0
                }

            },
            ...mapActions(['obtener_data', 'guardar_data', 'validar_seleccion_empresa', 'cerrar_sesion', 'obtener_nombre_empresa_seleccion']),
            ...mapMutations(['set_obj_solicitud_descuento', 'set_monto_en_efectivo', 'set_forma_de_pago', 'set_datos_cliente', 'set_carrito_facturador'])
        },
        async mounted() {
            let validacion = await this.validar_seleccion_empresa()
            if (validacion) {
                document.getElementById('campo_busqueda').focus()
                this.obtener_correlativos_sobres()

                // deje esta función aqui para que inserte el nombre de la empresa seleccionada en el componente de facturador, en caso de que sea un usuario de nivel 1, es decir, un administrador, se ejecuta esta función para obtener el nombre de la empresa seleccionada y se lo asigna a la variable nombre_empresa_seleccionada en el componen

                if (this.datos_usuario.nivel == 1) {
                    await this.obtener_nombre_empresa_seleccion()
                }

            }
        }
    }
</script>

<style>
    .contenedor_facturador_ {
        width: 100%;
        height: 100vh;
        display: flex;
    }

    .contenedor_productos {
        width: calc(100% - 300px);
        height: 100vh;
        /* border-right: 1px solid #e9e9e9; */
    }

    .cuadro_menus {
        width: 100%;
        height: 50px;
        background-color: #FF9D01;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 10px;
        padding-left: 10px;
    }

    .lista_productos {
        width: 100%;
        height: calc(100vh - 130px);
    }

    .cuadro_botones_accion {
        width: 100%;
        height: 80px;
        border-top: 1px solid #e9e9e9;
    }

    .buttons-container {
        display: flex;
    }

    .action-button {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 20px;
    }

    .action-button:hover {
        background-color: #f0f0f0;
    }

    .action-button:active {
        background-color: #e0e0e0;
    }

    .contenedor_datos_cliente {
        width: 300px;
        height: 100vh;
    }

    .titulo_datos_cliente {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        padding-right: 10px;
        font-weight: bold;
        font-size: 18px;
        background-color: #FF9D01;
    }

    .area_datos_cliente {
        width: 100%;
        height: 300px;
        /* padding: 10px; */
        border-left: 1px solid #e9e9e9;
        display: flex;
        justify-content: center;
        align-items: center;
        /* background-color: purple; */
    }


    .cuerpo_otros_datos {
        width: 100%;
        height: calc(100vh - 740px);
        border-left: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        position: relative;
    }

    .boton_total_factura {
        width: 100%;
        height: 130px;
        color: white;
    }

    .titulo_total {
        width: 100%;
        height: 40px;
        font-weight: bold;
        font-size: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .monto_total {
        width: 100%;
        height: calc(100% - 40px);
        font-weight: bold;
        font-size: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
    }

    .campo_busqueda_productos {
        width: 100%;
        height: 90px;
    }

    .contenedor_lista_productos {
        width: 100%;
        height: calc(100% - 90px);
        overflow: auto;
    }

    .botones_fuciones_extras {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        /* border: 1px solid black; */
    }

    .campo-texto-nit {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 30px;
        margin-bottom: 10px;
    }

    .campo-texto-nombre {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 20px;
        text-align: center;
    }

    .contenedor_sobres {
        width: 100%;
        position: absolute;
        bottom: 10px;
    }
</style>
